// ** React Imports
import { Fragment } from "react"

// ** Custom Components
import NavbarUser from "./NavbarUser"
import PageTitle from "./PageTitle"

// ** Third Party Components
import { Menu } from "react-feather"

// ** Reactstrap Imports
import { NavItem, NavLink } from "reactstrap"

const ThemeNavbar = (props) => {
  // ** Props
  // skin/setSkin siguen llegando desde el layout pero ya no se usan: el toggle de
  // tema se retiró con el rediseño (ver NavbarUser).
  const { setMenuVisibility } = props

  return (
    <Fragment>
      <div className="bookmark-wrapper d-flex align-items-center">
        <ul className="navbar-nav d-xl-none">
          <NavItem className="mobile-menu me-auto">
            <NavLink
              className="nav-menu-main menu-toggle hidden-xs is-active"
              onClick={() => setMenuVisibility(true)}
            >
              <Menu className="ficon" />
            </NavLink>
          </NavItem>
        </ul>
        <PageTitle />
      </div>
      <NavbarUser />
    </Fragment>
  )
}

export default ThemeNavbar
